import { defineStore } from "pinia"

export const useDataSelectionStore = defineStore({
  id: "dataSelection",
  state: () => ({
    selection: [] as any,
  }),
  getters: {
    selections: (state) => {
      return state.selection
    },
  },
  actions: {
    isSelectedAll(item: any) {
      if (!this.selection || this.selection.length === 0) {
        return false
      }
      return JSON.stringify(this.selection?.sort()) === JSON.stringify(item?.sort())
    },
    isSelected(item: any) {
      if (!this.selection || this.selection.length === 0) {
        return false
      }
      return this.selection.includes(item)
    },
    isIndeterminate(item: any) {
      if (!this.selection || this.selection.length === 0) {
        return false
      }
      return this.selection.length < item.length
    },
    toggleSelectAll(item: any) {
      if (this.isSelectedAll(item)) {
        this.selection = []
      } else {
        // Always reassign so deep watchers receive a new reference (not an in-place mutate).
        this.selection = [...item].sort()
      }
    },
    toggleSelect(item: any) {
      if (this.isSelected(item)) {
        this.selection = this.selection.filter((i: any) => i !== item)
      } else {
        // Reassign rather than push — deep watchers comparing oldValue/value need a new array.
        this.selection = [...this.selection, item].sort()
      }
    },
    select(item: any) {
      const index = this.selection.findIndex((i: any) => i === item)
      if (index === -1) {
        this.selection = [...this.selection, item].sort()
      }
    },
    deSelect(item: any) {
      this.selection = this.selection.filter((i: any) => i !== item)
    },
    clearSelection() {
      this.selection = []
    },
  },
})
